import { render, staticRenderFns } from "./RejectConfirmWorktype.vue?vue&type=template&id=ff054924"
import script from "./RejectConfirmWorktype.vue?vue&type=script&lang=js"
export * from "./RejectConfirmWorktype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports